export default __webpack_public_path__ + "static/media/Americantourister.c78fd3f4.jpg";